exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-filter__container[data-v-0a4b2bfd]{width:100%;height:100%}.image-filter__container .image-filter__header[data-v-0a4b2bfd]{width:100%;height:60px}.image-filter__container .image-filter__body[data-v-0a4b2bfd]{height:calc(100% - 60px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a4b2bfd","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/image-filter/image-filter.vue
// module id = 201
// module chunks = 0